export default class MapDestinations {
    constructor(map) {
        this.root = document.querySelector(map);
        if(!this.root) return; // bail

        this.current = null;
        this.points = this.root.querySelectorAll('[data-el]');

        this.points.forEach(el => {
            let rel = this.root.querySelectorAll('[data-el=' + el.getAttribute('data-el') + ']');

            el.addEventListener('mouseenter', (e) => {
                rel.forEach(r => {
                    r.classList.add('hover');
                });
            });
            el.addEventListener('mouseleave', (e) => {
                rel.forEach(r => {
                    r.classList.remove('hover');
                });
            });

            el.addEventListener('click', (e) => {
                e.preventDefault();
                let target = document.getElementById(el.getAttribute('data-el'));

                this.hide_info();
                this.show_info(target);
            }, this);
        }, this);

        this.root.querySelectorAll('.icon-close').forEach(el => {
            el.addEventListener('click', (e) => {
                this.hide_info();
            }, this);
        }, this);
    }
    show_info(target) {
        this.current = target;
        this.current.classList.add('is-open');


    }

    hide_info() {
        if(this.current) {
            this.current.classList.remove('is-open');
            this.current = null;
        }
    }
}